module.exports = __webpack_public_path__ + "static/media/10_1440.f333b45e.jpeg";